export const mergeFields = (
	currentValues: Record<string, unknown>,
	newValues: Record<string, unknown>,
) => {
	const result: Record<string, unknown> = { ...currentValues };

	for (const [key, value] of Object.entries(newValues)) {
		const current = result[key];

		if (
			typeof value === "object" &&
			value !== null &&
			!Array.isArray(value) &&
			typeof current === "object" &&
			current !== null &&
			!Array.isArray(current)
		) {
			result[key] = mergeFields(
				current as Record<string, unknown>,
				value as Record<string, unknown>,
			);
		} else {
			result[key] = value;
		}
	}

	return result;
};
